import React from 'react';
import exact from 'prop-types-exact';


import PageLayout from '../../layouts/PageLayout';


import PayPeriodSelector from './containers/PayPeriodSelector';
import PayPeriod from './containers/PayPeriod';


const propTypes = exact({});


const PayrollProcessorPage = (props) => {
  return (
    <PageLayout
      title="Payroll Processing"
      render={() => {
        return (
          <div>
            <div className="panel panel-default">
              <div className="panel-heading">
                <div className="panel-title">
                  <h3>
                    Timesheets Waiting for Approval and Missing Tickets
                  </h3>
                </div>
              </div>
              <div className="panel-body">
                <PayPeriodSelector />
                <PayPeriod />
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};


PayrollProcessorPage.propTypes = propTypes;


export default PayrollProcessorPage;
